import ActionsPage from 'components/ActionsPages/ActionsPage';
import { SwitchRenovation } from './SwitchRenovation';


export const ActionsPageRenovations = () => (
  <ActionsPage title="Gestión de vencimientos" switchAction={<SwitchRenovation />} />
);
